import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/lib/api'
import { queryKeys } from '@/lib/queryKeys'
import type { FleetSummary } from '@/types'

export function useFleetSummaryQuery() {
  return useQuery({
    queryKey: queryKeys.fleet.summary,
    queryFn: () => apiFetch<FleetSummary>('/v1/dashboard/fleet'),
    staleTime: 30_000,
    gcTime: 5 * 60_000,
  })
}
